import { Navigate, Outlet } from "react-router-dom";

import { resolvePostAuthRoute } from "../../../features/auth/utils/resolvePostAuthRoute";
import { useAuth } from "../../providers/AuthProvider";
import RouteFallback from "../fallback/RouteFallback";

export default function PublicAuthRoute() {
  const { isAuthenticated, status, user } = useAuth();

  if (status === "booting") return <RouteFallback />;

  if (isAuthenticated) {
    return <Navigate to={resolvePostAuthRoute(user)} replace />;
  }

  return <Outlet />;
}
